import { KeyboardEvent } from 'react';

export default function callIfEscapeKeyPressed(callback: () => void) {
  return (e: KeyboardEvent<any>) => {
    if (e.key === 'Escape') callback();
  };
}
